<template>
    <div>
        <router-view></router-view>

        <div class="position-relative">
            <div class="shape shape-bottom shape-fluid-x svg-shim text-gray-200">
                <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"/>
                </svg>
            </div>
        </div>

        <section class="py-6 py-md-8 bg-gray-200">
            <div class="container pb-6 pb-md-8">
                <div class="row align-items-center">
                    <div class="col-12 col-md">
                        <h3 class="mb-1 font-weight-bold">
                            Interested in learning more about AcreCX products?
                        </h3>
                        <p class="font-size-lg text-muted mb-6 mb-md-0">
                            Get a whitepaper written by our experts.
                        </p>
                    </div>
                    <div class="col-12 col-md-5">
                        <form>
                            <div class="row">
                                <div class="col">
                                    <input type="email" class="form-control" placeholder="Enter your email">
                                </div>
                                <div class="col-auto ml-n5">
                                    <button class="btn btn-success" type="submit">
                                        Send Whitepaper
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "ProductsLayout"
    }
</script>

<style scoped>

</style>